// Attaches the signed-in user's bearer token to every server function call so
// server-side middleware can verify the caller.
import { createMiddleware } from '@tanstack/react-start'

import { supabase } from './client'

export const attachSupabaseAuth = createMiddleware({ type: 'function' }).client(
  async ({ next }) => {
    if (typeof window === 'undefined') return next()

    try {
      const { data } = await supabase.auth.getSession()
      const token = data.session?.access_token
      if (token) {
        return next({ headers: { Authorization: `Bearer ${token}` } })
      }
    } catch {
      // Fall through as an anonymous call.
    }

    return next()
  },
)
